<div class="search-bar">
  <mat-form-field>
    <!-- Placeholder -->
    <mat-label>{{ 'label.search' | translate }}</mat-label>

    <!-- Input -->
    <input type="text" matInput [formControl]="inputControl" [matAutocomplete]="auto" />

    <!-- Autocomplete options -->
    <mat-autocomplete
      autoActiveFirstOption="true"
      #auto="matAutocomplete"
      (optionSelected)="selectOption($event.option.value)"
    >
      <mat-option *ngFor="let option of options$ | async" [value]="option.value" [disabled]="!option.enabled">
        {{ option.value | translate }}
      </mat-option>

      <div id="instructions" class="flex-grow-1 flex-row align-items-center justify-content-end">
        <div class="flex-row align-items-center">
          <i class="ri-arrow-up-down-line"></i><span>{{ 'action.navigate' | translate }}</span>
        </div>
        <div class="flex-row align-items-center">
          <mat-icon>keyboard_return</mat-icon><span>{{ 'action.select' | translate }}</span>
        </div>
      </div>
    </mat-autocomplete>
  </mat-form-field>
</div>
